import { render, staticRenderFns } from "./Style1.vue?vue&type=template&id=35122b5e&scoped=true&"
import script from "./Style1.vue?vue&type=script&lang=js&"
export * from "./Style1.vue?vue&type=script&lang=js&"
import style0 from "./Style1.vue?vue&type=style&index=0&id=35122b5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35122b5e",
  null
  
)

export default component.exports